// import React from 'react';
import React, { Suspense, lazy, useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Bushireforwedding from './pages/Bus Hire For Wedding in Pune';
import Busesforcorporateevent from './pages/Buses For Corporate Events';
import Seatertempo from './pages/25 Seater Tempo Traveller on Rent in Pune';
import Seaterbusonrentinpune from './pages/32 Seater Bus Rent in Pune';
import ThirtyfiveSeaterbusonrentinpune from './pages/35 Seater Bus on Rent in Pune';
import FourfiveSeaterbusonrentinpune from './pages/45 Seater Bus on Rent in Pune';
import FiftySeaterbusonrentinpune from './pages/50 Seater Bus On Rent in Pune';
import Punetoshirdibushire from './pages/Pune to Shirdi Bus Hire';
import Busrentalsforschooltripinpune from './pages/Bus Rentals For School Trips in Pune';
import Busbookingforweddindtripinpune from './pages/Bus booking for wedding in Pune';
import Busbookingformarriage from './pages/Bus Booking for Marriage';
import Busserviceforcorporatepune from './pages/Bus Service for Corporate Pune';
import Busonforeventinpune from './pages/Bus on Rent For Event in Pune';
import Busrentalsfortourpackage from './pages/Bus Rental for Tour Packages';
import Bushireforoutstation from './pages/Bus Hire for Outstation';
import Acbusonrentinpune from './pages/AC Bus On Rent in Pune';
import Punebushirerentalsservice from './pages/Pune Bus Hire Rental Service';
import Busserviceforpicnincinpune from './pages/Bus Service for Picnic in Pune';
import Nonacbusserviceinpune from './pages/Non Ac Bus Rental Service in Pune';
import Luxurybusrentalinpune from './pages/Luxury Bus Rental in Pune';
import Luxuryforceurbaniaonrentinpune from './pages/Luxury Force Urbania On Rent in Pune';
import Forceurbanialuxuryminibusonrent from './pages/Force Urbania Luxury Mini Bus On Rent';
import Punetobhimashankarjyotilingabushire from './pages/Pune to Bhimashankar Jyotirlinga Bus Hire in Pune';
import Punetoalibaugbusonrent from './pages/Pune to Alibaug Bus on Rent';
import Punetoganpatipulebeach from './pages/Pune to Ganpatipule Beach Bus Rental Service';
import Punetojyotilingadarshan from './pages/Pune to 5 Jyotirlinga Darshan Bus Hire';
import Punetokolhapurbusonrent from './pages/Pune to Kolhapur Bus on Rent';
import Punetomumbaidarshanbus from './pages/Pune to Mumbai Darshan Bus On Rent';
import Busonrentinpimpri from './pages/Bus On Rent in Pimpri Chinchwad';
import Bushireforschooltripinpune from './pages/Bus Hire for School Trips in Pune';
import Punetonashikbusonrent from './pages/Pune to Nashik Bus on Rent';
import Punetobusonrent from './pages/Pune to Bus On Rent';
import Punetopandharpurbushire from './pages/Pune to Pandharpur Bus Hire';
import Punetoaurangabadbus from './pages/Pune to Aurangabad Bus Hire On Rent';
import Punelocalbusonrent from './pages/Pune Local Bus on Rent';
import Bushirenearmepune from './pages/Bus Hire Near me Pune';
import Manyseaterbuses from './pages/32,35,40,45,50 Seater Bus on Rent in Pune';
import Punetolonavalabushire from './pages/Pune to Lonavala Bus Hire';
import Punetosadeteenshaktipeethbus from './pages/Pune Sade Teen Shakti Peeth Bus on Rent';
import Punetokonkandarshan from './pages/Pune to Konkan Darshan Bus Hire';
import Punetogoahire from './pages/Pune to Goa Bus Hire';
import Bushireinpimprichichwad from './pages/Bus Hire in Pimpri Chinchwad';
import Busonrentinhadapsar from './pages/Bus on Rent in Hadapsar';
import Busonrentinkharadi from './pages/Bus On Rent in Kharadi Pune';
import Busonrentinhinjewadi from './pages/Bus on Rent in Hinjewadi';
import Bushireforpicnicinpune from './pages/Bus Hire for Picnic in Pune';
import Corporatetravelsinpune from './pages/Corporate Travels in Pune';
import Jyotilingadarshantourpackage from './pages/12 Jyotirlinga Darshan Tour Package from Pune';
import Punwtorajashthandarshan from './pages/Pune to Rajasthan Darshan Bus Package';
import Touristbusrentalsservice from './pages/Tourist Bus Rental Services';
import Monthlybushireserviceinpune from './pages/Monthly Bus Hire Service in Pune';
import Punetomatheranbustravels from './pages/Pune to Matheran Bus Travel';
import Bushireforpunetolonavala from './pages/Bus hire for Pune to Lonavala';
import Busonrentinpunetoashtavinayak from './pages/Bus on Rent for Pune to Ashtavinayak Darshan';
import Bushireforpunetomaharashtradarshan from './pages/Bus hire for Pune to Maharashtra Darshan';
import Bushireforkedarnathtrip from './pages/Bus Hire For Kedarnath Trip';
import Punetohyderbadbus from './pages/Pune to Hyderabad Bus On Rent';
import Bushireserviceforpune from './pages/Bus Hire Service for Pune Airport';
import Punetomahabaleshwarbusonrentservice from './pages/Pune to Mahabaleshwar Bus On Rent Service';
import Punetobhimashankarbusonrentinpune from './pages/Pune to Bhimashankar Bus on Rent in Pune';
import Bushireforpunetoashtavinayak from './pages/Bus hire for Pune to Ashtavinayak';
import Volvobusonrentinpune from './pages/Volvo Bus On Rent in Pune';
import Seaterfive from './pages/25 Seater Bus On Rent in Pune';
import Busonrentinpune from './pages/Bus On Rent in Pune';
import Rentabusforatrip from './pages/Rent a Bus For a Trip';
import Bharatbenzbusonrent from './pages/Bharatbenz Bus On Rent in Pune';
import Punebushireonlinebooking from './pages/Pune Bus hire Online Booking Service';
import Bushireinpune from './pages/Bus Hire in Pune';
import Bushireinbaner from './pages/Bus Hire in Baner Pune';
import Urbaniaonrentinpune from './pages/Urbania On Rent in Pune';
import Urbaniaonrentinpunecorporate from './pages/Urbania On Rent in Pune for Corporate';
import Urbaniainchichwad from './pages/Urbania On Rent in Pimpri Chinchwad';
import Thirtinseaterurbania from './pages/13 Seater Force Urbania on rent in Pune';
import Punetoshirdiurbania from './pages/Pune to Shirdi Urbania On Rent';
import Punetomumbaiurbania from './pages/Pune to Mumbai Urbania On Rent';
import Punetogoaurbaniaonrent from './pages/Pune to Goa Urbania On Rent';
import Minibusonrent from './pages/Mini Bus On Rent';
import Sevntinseater from './pages/17 Seater Bus on Rent Pune';
import Punetonearbyplaces from './pages/Pune to Nearby Places Picnic Spot Bus On Rent';
import Travelsagentsinpuneforfullbushire from './pages/Travel Agents in Pune for Full Bus Hire';
import Tempotravellerhire from './pages/Tempo Traveller Hire in Pune';
import Exploreallindiabushire from './pages/Explore All India Bus Hire Services From Pune';
import Fourfiveseateracbus from './pages/45 Seater AC Bus On Rent in Pune';
import Thirtifiveseateracbus from './pages/35 Seater AC Bus On Rent in Pune';
import Fivethreesater from './pages/53 Seater AC Bharat Benz on Rent Pune';
import Fourseaterbharat from './pages/45 Seater AC Bharat Benz On Rent Pune';
import Thirtifivedeater from './pages/35 Seater AC Bharat Benz Hire in Pune';
import Fourtyseater from './pages/40 Seater AC Bharat Benz on Rent in Pune';
import Twofiveseaterbus from './pages/25 Seater Tata Bus On Rent in Pune';
import ACfourtfive from './pages/Ac 45 Seater Bharat Benz Hire in Pune';
import Ashoklayland from './pages/Ashok Leyland Ac 45 Seater Bus Hire in Pune';
import Luxuryacseater from './pages/Luxury Ac 32 Seater Tata Bus On Rent in Pune';
import Actwentyfourseater from './pages/Ac 24 Seater Tata Bus Hire in Pune';
import Luxuryacthree from './pages/Luxury Ac 36 Seater Bharat Benz Bus on Rent Pune';
import Fiftythreeseater from './pages/53 Seater Volvo Bus Hire Pune';
import Fiftythreebharat from './pages/53 Seater Bharat Benz Bus On Rent in Pune';
import Fourzeroseater from './pages/40 Seater Bharat Benz Bus Hire Pune';
import Fiftyseaterbusinpimpri from './pages/50 Seater Bus On Rent in Pimpri Chinchwad';
import Onetwojyotilinga from './pages/12 Jyotirlinga Darshan Bus Hire in Pune';
import Ashtavinayakdarshanbusonrent from './pages/Ashtavinayak Darshan Bus On Rent in Pune';
import Corporatebusservice from './pages/Corporate Bus Services in Pune';
import Corporatevents from './pages/Corporate Events Bus On Rent in Pune';
import Topratesbus from './pages/Top Rated Bus Hire in Pune Amruta Travels';
import Acfourfivebharat from './pages/Ac 45 Seater Bharat Benz Bus Hire Shirdi';
import Acfourfiveseater from './pages/Ac 45 Seater Bharat Benz Bus Hire Aurangabad';
import Acluxuryfourfive from './pages/Ac Luxury 45 Seater Bharat Benz Bus Hire Ahmednagar';
import Acluxuryfourfiveseater from './pages/Ac Luxury 45 Seater Bus Hire Nashik';
import Outstationbushireservice from './pages/Outstation Bus Hire Service in Pune';
import Punetopanindian from './pages/Pune to Pan India Bus Service Amruta Travels';
import Volvosleeperbus from './pages/Volvo Sleeper Bus on Rent in Pune';
import Bestluxurybushire from './pages/Best Luxury Bus Hire in Pune';
import ContactButtons from './components/ContactButtons copy';
// import { incrementVisitCount } from './components/tracker';
import CaptchaPage from './components/CaptchaPage';
import {
  incrementClickCount,
  resetClickCount,
} from './components/tracker';
import ReactGA from 'react-ga4';
import Forceurbaniaseventineseater from './pages/Force Urbania 17 Seater On Rent in Pune';
import Urbaniahireinpune from './pages/Urbania Hire in Pune';
import Urbaniahireinurbaniaonrentinpune from './pages/Urbania Hire in Urbania On Rent Pune';
import Urbaniahireforcorporateeventspune from './pages/Urbania Hire for Corporate Events Pune ';
import Bookforceurbaniaonrentinpune from './pages/Book Force Urbania on Rent in Pune';
import Forceurbaniaonrentinpune from './pages/Force Urbania On Rent Pune';
import Onethreeurbaniaonrentinpune from './pages/13 Seater Urbania On Rent in Pune';
import Outstationurbaniaonrentpune from './pages/Outstation Urbania On Rent Pune';
import Urbaniaonrentinpuneforfamily from './pages/Urbania on rent in Pune for family Trip';
import Urbaniarentalservicepune from './pages/Urbania Rental Services Pune';
import Forceurbaniarentperkm from './pages/Force Urbania Rent Per km in Pune';
import Cheapurbaniarentalinpune from './pages/Cheap Urbania rental in Pune';
import Urbaniabusrentalsserviceinpune from './pages/Urbania Bus Rental Service in Pune';
import Puneairporturbaniaonrent from './pages/Pune Airport Urbania on Rent';
import Urbaniaonrentinkharadi from './pages/Urbania On Rent in Kharadi';
import UrbaniaBusSection from './pages/UrbaniaBusSection';
import Forceurbaniarentalinwagholipune from './pages/Force Urbania Rental in Wagholi Pune';
import Urbaniaonrentinvimannagar from './pages/Urbania on rent in Viman Nagar Pune';
import Urbaniahireinhadapsarpune from './pages/Urbania hire in Hadapsar Pune';
import Urbaniaonrentinkothrudpune from './pages/Urbania On Rent in Kothrud Pune';
import Forceurbaniarentalinaundhpune from './pages/Force Urbania rental in Aundh Pune';
import Urbaniaonrentinbanerpune from './pages/Urbania on Rent in Baner Pune';
import Urbaniahireinpimplesaudagarpune from './pages/Urbania hire in Pimple Saudagar Pune';
import Urbaniahireserviceinbhosaripune from './pages/Urbania hire service in Bhosari Pune';
import Urbaniaonrentinkatrajpune from './pages/Urbania on rent in Katraj Pune';
import Urbaniahireforpunedarshan from './pages/Urbania Hire for Pune Darshan';
import Urbaniarentalsinkarvenagarkothrud from './pages/Urbania Rental in Karve Nagar Kothrud';
import Urbaniahirehireforcorporateinpune from './pages/Urbania Hire for Corporate in Pune';
import Punetoashtavinayakdarshanurbania from './pages/Pune to Ashtavinayak darshan Urbania Hire';
import Amrutatravelspune from './pages/Amruta Travels Pune';
import Urbaniaonrentinpunecontactnumber from './pages/Urbania On Rent in Pune Contact Number';
import BusRentalInPune from "./pages/BusRentalInPune";
import BusRentalInBaner from "./pages/BusRentalInBaner";
import BusRentalInHinjawadi from "./pages/BusRentalInHinjawadi";
import BusRentalInWakad from "./pages/BusRentalInWakad";
import BusRentalInKharadi from "./pages/BusRentalInKharadi";
import BusRentalInHadapsar from "./pages/BusRentalInHadapsar";
import BusRentalInVimanNagar from "./pages/BusRentalInVimanNagar";
import BusRentalInAundh from "./pages/BusRentalInAundh";
import BusRentalInKothrud from "./pages/BusRentalInKothrud";
import BusRentalInPimpri from "./pages/BusRentalInPimpri";
import BusRentalInChinchwad from "./pages/BusRentalInChinchwad";

const HeroSection = lazy(() => import('./pages/HeroSection'));
const About = lazy(() => import('./pages/About'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('./pages/TermsConditions'));
const FAQ = lazy(() => import('./pages/FAQ'));

const Service = lazy(() => import('./pages/Service'));
const Packages = lazy(() => import('./pages/Packages'));
const Booking = lazy(() => import('./pages/Booking'));
const Events = lazy(() => import('./pages/OurFleet'));
const Gallery = lazy(() => import('./pages/Gallery'));
const Blog = lazy(() => import('./pages/Blog'));
const Contact = lazy(() => import('./pages/Contact'));
const Enquiry = lazy(() => import('./pages/Enquiry'));
const CareersSection = lazy(() => import('./pages/CareersSection'));




function App() {


   useEffect(() => {
    ReactGA.initialize('G-VYB6649VPC');
    ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search });
  }, []);


const [showCaptcha, setShowCaptcha] = useState(false);

  useEffect(() => {
    const count = incrementClickCount();
    if (count >= 8) {
      setShowCaptcha(true);
    }
  }, []);

  const handleCaptchaSuccess = () => {
    resetClickCount();
    setShowCaptcha(false);
  };

  if (showCaptcha) {
    return <CaptchaPage onSuccess={handleCaptchaSuccess} />;
  }

  return (
    <Router>
      <Header />
      {/* <ContactButtons/> */}
     <ScrollToTop/>
<ContactButtons/>
      <Suspense fallback={<div className="text-center py-5">Loading...</div>}>
  <Routes>

        <Route path="/" element={<HeroSection />} />
        <Route path="/about" element={<About />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/Faqs" element={<FAQ />} />
        <Route path="/services" element={<Service />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/our-fleet" element={<Events />} />

        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/Careers" element={<CareersSection />} />






<Route path="/Bus-Hire-For-Wedding-in-Pune" element={<Bushireforwedding />} />
<Route path="/Buses-For-Corporate-Events" element={<Busesforcorporateevent />} />
<Route path="/25-Seater-Tempo-Traveller-on-Rent-in-Pune" element={<Seatertempo />} />
<Route path="/32-Seater-Bus-Rent-in-Pune" element={<Seaterbusonrentinpune />} />
<Route path="/35-Seater-Bus-on-Rent-in-Pune" element={<ThirtyfiveSeaterbusonrentinpune />} />
<Route path="/45-Seater-Bus-on-Rent-in-Pune" element={<FourfiveSeaterbusonrentinpune />} />
<Route path="/50-Seater-Bus-On-Rent-in-Pune" element={<FiftySeaterbusonrentinpune />} />
<Route path="/Pune-to-Shirdi-Bus-Hire" element={<Punetoshirdibushire />} />
<Route path="/Bus-Rentals-For-School-Trips-in-Pune" element={<Busrentalsforschooltripinpune />} />
<Route path="/Bus-booking-for-wedding-in-Pune" element={<Busbookingforweddindtripinpune />} />
<Route path="/Bus-Booking-for-Marriage" element={<Busbookingformarriage />} />
<Route path="/Bus-Service-for-Corporate-Pune" element={<Busserviceforcorporatepune />} />
<Route path="/Bus-on-Rent-For-Event-in-Pune" element={<Busonforeventinpune />} />
<Route path="/Bus-Rental-for-Tour-Packages" element={<Busrentalsfortourpackage />} />
<Route path="/Bus-Hire-for-Outstation" element={<Bushireforoutstation />} />
<Route path="/AC-Bus-On-Rent-in-Pune" element={<Acbusonrentinpune />} />
<Route path="/Pune-Bus-Hire-Rental-Service" element={<Punebushirerentalsservice />} />
<Route path="/Bus-Service-for-Picnic-in-Pune" element={<Busserviceforpicnincinpune />} />
<Route path="/Non-Ac-Bus-Rental-Service-in-Pune" element={<Nonacbusserviceinpune />} />
<Route path="/Luxury-Bus-Rental-in-Pune" element={<Luxurybusrentalinpune />} />
<Route path="/Luxury-Force-Urbania-On-Rent-in-Pune" element={<Luxuryforceurbaniaonrentinpune />} />
<Route path="/Force-Urbania-Luxury-Mini-Bus-On-Rent" element={<Forceurbanialuxuryminibusonrent />} />
<Route path="/Pune-to-Bhimashankar-Jyotirlinga-Bus-Hire-in-Pune" element={<Punetobhimashankarjyotilingabushire />} />
<Route path="/Pune-to-Alibaug-Bus-on-Rent" element={<Punetoalibaugbusonrent />} />
<Route path="/Pune-to-Ganpatipule-Beach-Bus-Rental-Service" element={<Punetoganpatipulebeach />} />
<Route path="/Pune-to-5-Jyotirlinga-Darshan-Bus-Hire" element={<Punetojyotilingadarshan />} />
<Route path="/Pune-to-Kolhapur-Bus-on-Rent" element={<Punetokolhapurbusonrent />} />
<Route path="/Pune-to-Mumbai-Darshan-Bus-On-Rent" element={<Punetomumbaidarshanbus />} />
<Route path="/Bus-On-Rent-in-Pimpri-Chinchwad" element={<Busonrentinpimpri />} />
<Route path="/Bus-Hire-for-School-Trips-in-Pune" element={<Bushireforschooltripinpune />} />
<Route path="/Pune-to-Nashik-Bus-on-Rent" element={<Punetonashikbusonrent />} />
<Route path="/Pune-to-Bus-On-Rent" element={<Punetobusonrent />} />
<Route path="/Pune-to-Pandharpur-Bus-Hire" element={<Punetopandharpurbushire />} />


<Route path="/Pune-to-Aurangabad-Bus-Hire-On-Rent" element={<Punetoaurangabadbus />} />
<Route path="/Pune-Local-Bus-on-Rent" element={<Punelocalbusonrent />} />
<Route path="/Bus-Hire-Near-me-Pune" element={<Bushirenearmepune />} />
<Route path="/32-35-40-45-50-Seater-Bus-on-Rent-in-Pune" element={<Manyseaterbuses />} />
<Route path="/Pune-to-Lonavala-Bus-Hire" element={<Punetolonavalabushire />} />
<Route path="/Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" element={<Punetosadeteenshaktipeethbus />} />
<Route path="/Pune-to-Konkan-Darshan-Bus-Hire" element={<Punetokonkandarshan />} />
<Route path="/Pune-to-Goa-Bus-Hire" element={<Punetogoahire />} />
<Route path="/Bus-Hire-in-Pimpri-Chinchwad" element={<Bushireinpimprichichwad />} />
<Route path="/Bus-on-Rent-in-Hadapsar" element={<Busonrentinhadapsar />} />
<Route path="/Bus-on-Rent-in-Kharadi-Pune" element={<Busonrentinkharadi />} />
<Route path="/Bus-on-Rent-in-Hinjewadi" element={<Busonrentinhinjewadi />} />
<Route path="/Bus-Hire-for-Picnic-in-Pune" element={<Bushireforpicnicinpune />} />
<Route path="/Corporate-Travels-in-Pune" element={<Corporatetravelsinpune />} />
<Route path="/12-Jyotirlinga-Darshan-Tour-Package-from-Pune" element={<Jyotilingadarshantourpackage />} />
<Route path="/Pune-to-Rajasthan-Darshan-Bus-Package" element={<Punwtorajashthandarshan />} />
<Route path="/Tourist-Bus-Rental-Services" element={<Touristbusrentalsservice />} />
<Route path="/Monthly-Bus-Hire-Service-in-Pune" element={<Monthlybushireserviceinpune />} />
<Route path="/Pune-to-Matheran-Bus-Travel" element={<Punetomatheranbustravels />} />
<Route path="/Bus-Hire-for-Pune-to-Lonavala" element={<Bushireforpunetolonavala />} />
<Route path="/Bus-on-Rent-for-Pune-to-Ashtavinayak-Darshan" element={<Busonrentinpunetoashtavinayak />} />
<Route path="/Bus-Hire-for-Pune-to-Maharashtra-Darshan" element={<Bushireforpunetomaharashtradarshan />} />
<Route path="/Bus-Hire-for-Kedarnath-Trip" element={<Bushireforkedarnathtrip />} />
<Route path="/Pune-to-Hyderabad-Bus-on-Rent" element={<Punetohyderbadbus />} />
<Route path="/Bus-Hire-Service-for-Pune-Airport" element={<Bushireserviceforpune />} />
<Route path="/Pune-to-Mahabaleshwar-Bus-on-Rent-Service" element={<Punetomahabaleshwarbusonrentservice />} />
<Route path="/Pune-to-Bhimashankar-Bus-on-Rent" element={<Punetobhimashankarbusonrentinpune />} />
<Route path="/Bus-Hire-for-Pune-to-Ashtavinayak" element={<Bushireforpunetoashtavinayak />} />
<Route path="/Volvo-Bus-on-Rent-in-Pune" element={<Volvobusonrentinpune />} />
<Route path="/25-Seater-Bus-on-Rent-in-Pune" element={<Seaterfive />} />
<Route path="/Bus-on-Rent-in-Pune" element={<Busonrentinpune />} />
<Route path="/Rent-a-Bus-For-a-Trip" element={<Rentabusforatrip />} />

<Route path="/Bharatbenz-Bus-On-Rent-in-Pune" element={<Bharatbenzbusonrent />} />
<Route path="/Pune-Bus-hire-Online-Booking-Service" element={<Punebushireonlinebooking />} />
<Route path="/Bus-Hire-in-Pune" element={<Bushireinpune />} />
<Route path="/Bus-Hire-in-Baner-Pune" element={<Bushireinbaner />} />
<Route path="/Urbania-On-Rent-in-Pune" element={<Urbaniaonrentinpune />} />
<Route path="/Urbania-On-Rent-in-Pune-for-Corporate" element={<Urbaniaonrentinpunecorporate />} />
<Route path="/Urbania-On-Rent-in-Pimpri-Chinchwad" element={<Urbaniainchichwad />} />
<Route path="/13-Seater-Force-Urbania-on-rent-in-Pune" element={<Thirtinseaterurbania />} />
<Route path="/Pune-to-Shirdi-Urbania-On-Rent" element={<Punetoshirdiurbania />} />
<Route path="/Pune-to-Mumbai-Urbania-On-Rent" element={<Punetomumbaiurbania />} />
<Route path="/Pune-to-Goa-Urbania-On-Rent" element={<Punetogoaurbaniaonrent />} />
<Route path="/Mini-Bus-On-Rent" element={<Minibusonrent />} />
<Route path="/17-Seater-Bus-on-Rent-Pune" element={<Sevntinseater />} />
<Route path="/Pune-to-Nearby-Places-Picnic-Spot-Bus-On-Rent" element={<Punetonearbyplaces />} />
<Route path="/Travel-Agents-in-Pune-for-Full-Bus-Hire" element={<Travelsagentsinpuneforfullbushire />} />
<Route path="/Tempo-Traveller-Hire-in-Pune" element={<Tempotravellerhire />} />
<Route path="/Explore-All-India-Bus-Hire-Services-From-Pune" element={<Exploreallindiabushire />} />
<Route path="/45-Seater-Ac-Bus-On-Rent-in-Pune" element={<Fourfiveseateracbus />} />
<Route path="/35-Seater-Ac-Bus-On-in-Pune" element={<Thirtifiveseateracbus />} />
<Route path="/53-Seater-Ac-Bharat-Benz-on-Rent-Pune" element={<Fivethreesater />} />
<Route path="/45-Seater-Ac-Bharat-Benz-On-Rent-Pune" element={<Fourseaterbharat />} />
<Route path="/35-Seater-Ac-Bharat-Benz-Hire-in-Pune" element={<Thirtifivedeater />} />
<Route path="/40-Seater-Ac-Bharat-Benz-on-Rent-in-Pune" element={<Fourtyseater />} />
<Route path="/25-Seater-Tata-Bus-On-Rent-in-Pune" element={<Twofiveseaterbus />} />



<Route path="/Ac-45-Seater-Bharat-Benz-Hire-in-Pune" element={<ACfourtfive />} />
<Route path="/Ashok-Leyland-Ac-45-Seater-Bus-Hire-in-Pune" element={<Ashoklayland />} />
<Route path="/Luxury-Ac-32-Seater-Tata-Bus-On-Rent-in-Pune" element={<Luxuryacseater />} />
<Route path="/Ac-24-Seater-Tata-Bus-Hire-in-Pune" element={<Actwentyfourseater />} />
<Route path="/Luxury-Ac-36-Seater-Bharat-Benz-Bus-on-Rent-Pune" element={<Luxuryacthree />} />
<Route path="/53-Seater-Volvo-Bus-Hire-Pune" element={<Fiftythreeseater />} />
<Route path="/53-Seater-Bharat-Benz-Bus-On-Rent-in-Pune" element={<Fiftythreebharat />} />
<Route path="/40-Seater-Bharat-Benz-Bus-Hire-Pune" element={<Fourzeroseater />} />
<Route path="/50-Seater-Bus-On-Rent-in-Pimpri-Chinchwad" element={<Fiftyseaterbusinpimpri />} />
<Route path="/12-Jyotirlinga-Darshan-Bus-Hire-in-Pune" element={<Onetwojyotilinga />} />
<Route path="/Ashtavinayak-Darshan-Bus-On-Rent-in-Pune" element={<Ashtavinayakdarshanbusonrent />} />
<Route path="/Corporate-Bus-Services-in-Pune" element={<Corporatebusservice />} />
<Route path="/Corporate-Events-Bus-On-Rent-in-Pune" element={<Corporatevents />} />
<Route path="/Top-Rated-Bus-Hire-in-Pune-Amruta-Travels" element={<Topratesbus />} />
<Route path="/Ac-45-Seater-Bharat-Benz-Bus-Hire-Shirdi" element={<Acfourfivebharat />} />
<Route path="/Ac-45-Seater-Bharat-Benz-Bus-Hire-Aurangabad-Sambhaji-Nagar" element={<Acfourfiveseater />} />
<Route path="/Ac-Luxury-45-Seater-Bharat-Benz-Bus-Hire-Ahmednagar" element={<Acluxuryfourfive />} />
<Route path="/Ac-Luxury-45-Seater-Bus-Hire-Nashik" element={<Acluxuryfourfiveseater />} />
<Route path="/Outstation-Bus-Hire-Service-in-Pune" element={<Outstationbushireservice />} />
<Route path="/Pune-to-Pan-India-Bus-Service-Amruta-Travels" element={<Punetopanindian />} />
<Route path="/Volvo-Sleeper-Bus-on-Rent-in-Pune" element={<Volvosleeperbus />} />
<Route path="/Best-Luxury-Bus-Hire-in-Pune" element={<Bestluxurybushire />} />


<Route path="/Force-Urbania-17-Seater-On-Rent-in-Pune" element={<Forceurbaniaseventineseater />} />
<Route path="/Urbania-Hire-in-Pune" element={<Urbaniahireinpune />} />
<Route path="/Urbania-Hire-for-Corporate-Events-Pune" element={<Urbaniahireforcorporateeventspune />} />
<Route path="/Book-Force-Urbania-on-Rent-in-Pune" element={<Bookforceurbaniaonrentinpune />} />
<Route path="/Force-Urbania-On-Rent-Pune" element={<Forceurbaniaonrentinpune />} />
<Route path="/13-Seater-Urbania-On-Rent-in-Pune" element={<Onethreeurbaniaonrentinpune />} />
<Route path="/Outstation-Urbania-On-Rent-Pune" element={<Outstationurbaniaonrentpune />} />
<Route path="/Urbania-on-rent-in-Pune-for-family-Trip" element={<Urbaniaonrentinpuneforfamily />} />
<Route path="/Urbania-Rental-Services-Pune" element={<Urbaniarentalservicepune />} />
<Route path="/Force-Urbania-Rent-Per-km-in-Pune" element={<Forceurbaniarentperkm />} />
<Route path="/Cheap-Urbania-rental-in-Pune" element={<Cheapurbaniarentalinpune />} />
<Route path="/Urbania-Bus-Rental-Service-in-Pune" element={<Urbaniabusrentalsserviceinpune />} />
<Route path="/Pune-Airport-Urbania-on-Rent" element={<Puneairporturbaniaonrent />} />
<Route path="/Urbania-On-Rent-in-Kharadi" element={<Urbaniaonrentinkharadi />} />
<Route path="/Force-Urbania-Rental-in-Wagholi-Pune" element={<Forceurbaniarentalinwagholipune />} />
<Route path="/Urbania-on-rent-in-Viman-Nagar-Pune" element={<Urbaniaonrentinvimannagar />} />
<Route path="/Urbania-hire-in-Hadapsar-Pune" element={<Urbaniahireinhadapsarpune />} />
<Route path="/Urbania-On-Rent-in-Kothrud-Pune" element={<Urbaniaonrentinkothrudpune />} />
<Route path="/Force-Urbania-rental-in-Aundh-Pune" element={<Forceurbaniarentalinaundhpune />} />
<Route path="/Urbania-on-Rent-in-Baner-Pune" element={<Urbaniaonrentinbanerpune />} />
<Route path="/Urbania-hire-in-Pimple-Saudagar-Pune" element={<Urbaniahireinpimplesaudagarpune />} />
<Route path="/Urbania-hire-service-in-Bhosari-Pune" element={<Urbaniahireserviceinbhosaripune />} />
<Route path="/Urbania-on-rent-in-Katraj-Pune" element={<Urbaniaonrentinkatrajpune />} />
<Route path="/Urbania-Hire-for-Pune-Darshan" element={<Urbaniahireforpunedarshan />} />
<Route path="/Urbania-Rental-in-Karve-Nagar-Kothrud" element={<Urbaniarentalsinkarvenagarkothrud />} />
<Route path="/Urbania-Hire-for-Corporate-in-Pune" element={<Urbaniahirehireforcorporateinpune />} />
<Route path="/Pune-to-Ashtavinayak-darshan-Urbania-Hire" element={<Punetoashtavinayakdarshanurbania />} />
<Route path="/Amruta-Travels-Pune" element={<Amrutatravelspune />} />
<Route path="/Urbania-On-Rent-in-Pune-Contact-Number" element={<Urbaniaonrentinpunecontactnumber />} />
  <Route
    path="/bus-rental-in-hinjawadi"
    element={<BusRentalInHinjawadi />}
/>
<Route
    path="/bus-rental-in-baner"
    element={<BusRentalInBaner />}
/>
<Route
    path="/bus-rental-in-kothrud"
    element={<BusRentalInKothrud />}
/>
<Route
    path="/bus-rental-in-pimpri"
    element={<BusRentalInPimpri />}
/>
<Route
    path="/bus-rental-in-kharadi"
    element={<BusRentalInKharadi />}
/>
<Route
    path="/bus-rental-in-hadapsar"
    element={<BusRentalInHadapsar />}
/>
<Route
    path="/bus-rental-in-chinchwad"
    element={<BusRentalInChinchwad />}
/>
<Route
    path="/bus-rental-in-viman-nagar"
    element={<BusRentalInVimanNagar />}
/>
<Route
    path="/bus-rental-in-aundh"
    element={<BusRentalInAundh />}
/>
<Route
    path="/bus-rental-in-wakad"
    element={<BusRentalInWakad />}
/>
  <Route
    path="/bus-rental-in-pune"
    element={<BusRentalInPune />}
/>
      </Routes>
</Suspense>
<Footer />
    </Router>
  );
}

export default App;
